export const _LOAD_MODEL_ = 'Load:QuotationModel';
export const _OPEN_MODAL_ = 'Open:Quotation';
export const _DELETE_QUOTATION_ = 'Delete:Quotation';
export const _FINISHED_SAVE_REQUEST_ = 'SaveRequest:Finished';
export const _UPDATE_QUOTATION_ROWS_ = 'Update:UpdateQuotation';
export const _SALVE_QUOTATION_SUCCESS_ = 'Salve:QuotationSuccess';

export const STATUS_OPTIONS = [
  { slug: 'open', name: 'Rascunho' },
  { slug: 'pending', name: 'Pendente' },
  { slug: 'approved', name: 'Aprovado' },
  { slug: 'canceled', name: 'Cancelado' },
  { slug: 'closed', name: 'Concluído' },
];

export const PRODUCT_UNITS_OPTIONS = [
  { id: null, name: null, description: '' },
];

export const OPENING = [
  { value: 'null', text: 'Selecione uma abertura' },
  { value: 'left', text: 'Esquerda' },
  { value: 'right', text: 'Direita' },
  { value: 'center', text: 'Central' },
  { value: 'inverted', text: 'Lateral Invertida' },
];

export const THICKNESSES = [
  { value: null, text: 'Selecione uma espessura' },
  { value: 0.32, text: '32mm' },
  { value: 0.38, text: '38mm' },
  { value: 0.45, text: '45mm' },
  { value: 0.50, text: '50mm' },
];

export const TYPE_OPTIONS = [
  { id: null, slug: null, name: null },
];

export const PAYMENT_TYPE_OPTIONS = [
  { id: null, name: null, slug: null },
];

export const PELMETS = [
  { value: 'null', text: 'Selecione um tipo' },
  { value: 'full', text: 'Normal' },
  { value: 'left', text: 'Aba Esquerda' },
  { value: 'right', text: 'Aba Direita' },
  { value: 'without_flaps', text: 'Sem abas' },
];

export const CUSTOMER = {
  id: null,
  name: null,
  document: null,
};

export const BLINDS = {
  id: null,
  gap: false,
  area: 0,
  furl: 'normal', // enrolamento
  color: null,
  width: 0,
  height: 0,
  pelmet: false, // bandô
  comment: null,
  opening: null, // abertura
  parapet: 0, // parapeito
  reducer: false, // redutor
  hasEngine: false,
  thickness: null, // espessura
  collection: null,
  engineSide: null,
  engineVolts: null,
  pelmet_type: 'full',
  blinds_type_id: 5,
  additional_cost: 0,
};

export const ROW = {
  id: null,
  total: 1.00,
  value: 1.00,
  step: 0.01,
  blinds: null,
  quantity: 1,
  unit_type: 'm²',
  description: null,
};

export const MODEL = {
  id: null,
  rows: [{ ...ROW }],
  total: 0.00,
  status: 'open',
  parcel: 1,
  quotation_type: null,
  comment: null,
  discount: 0.00,
  subtotal: 0.00,
  valid_at: null,
  started_date: null,
  parcel_value: 0.00,
  delivery_date: null,
  delivery_time: null,
  duration_time: null,
  payment_info: 'Pagamento em 30 dias',
  discount_type: 'pct',
  customer: { ...CUSTOMER },
  customer_id: '',
  customer_name: '',
};
